import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios';

Vue.prototype.$http = axios;
Vue.config.productionTip = false
new Vue({
  router,
  store,
  data: {
    user_token:'',
    site_id:'',
  },
  render: h => h(App)
}).$mount('#app')
window.jivo_onLoadCallback = () => {
  setTimeout(() => {
    const jdivElements = document.getElementsByTagName('jdiv');
    const jivoTarget = jdivElements[1];
    if (jivoTarget) {
      store.dispatch('updateJivoElements', jivoTarget);
      jivoTarget.style.display = 'none';
    } else {
      console.log('No se encontró el jdiv a ocultar');
    }
    store.commit('setWidget', true);
  }, 700); // ajusta el tiempo según necesidad
};
window.jivo_onClose = () => {
  jivo_api.open()
  const jivoElement1 = store.getters['jivoElement1'];
  if (jivoElement1 ) {
    jivoElement1.style.display = 'none';
  }
  store.state.jivo_modal_flag = false;
}
window.jivo_onOpen = () => {
  const jivoElement1 = store.getters['jivoElement1'];
  if (jivoElement1 ) {
    jivoElement1.style.display = 'block';
  }

}
window.jivo_onMessageReceived = () => {
	console.log(`Check agents messages`);
  store.state.message_recived = true;
}